var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContaroLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 47,
    viewBox: "0 0 30 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7622 46.6531C9.25487 46.6531 6.24336 44.9817 3.74602 41.6389C1.24867 38.296 0 34.2547 0 29.5149C0 24.775 1.24867 20.7087 3.74602 17.341C6.24336 13.9981 9.25487 12.3018 12.7622 12.3018H20.5296C20.5296 15.0209 19.9971 17.1164 18.9321 18.5633C17.867 20.0102 16.5633 20.7586 15.0575 20.7586H12.7622C11.0177 20.7586 9.53031 21.6318 8.28164 23.3531C7.05133 25.0993 6.42699 27.1449 6.42699 29.5149C6.42699 31.8848 7.05133 33.9304 8.28164 35.6268C9.51194 37.3481 11.0177 38.1962 12.7622 38.1962H15.0575C16.5633 38.1962 17.8487 38.9197 18.9321 40.3666C19.9971 41.8135 20.5296 43.909 20.5296 46.6282H12.7622V46.6531Z",
    fill: "url(#paint0_linear_10955_49786)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7691 -4.34774e-05C20.2764 -4.30608e-05 23.2879 1.67137 25.7852 5.01421C28.2826 8.35704 29.5313 12.3984 29.5313 17.1382C29.5313 21.8781 28.2826 25.9443 25.7852 29.3121C23.2879 32.655 20.2764 34.3513 16.7691 34.3513L9.00161 34.3513C9.00161 31.6321 9.53413 29.5366 10.5992 28.0897C11.6642 26.6428 12.968 25.8944 14.4737 25.8944L16.7691 25.8944C18.5136 25.8944 20.0009 25.0213 21.2496 23.3C22.4799 21.5538 23.1043 19.5081 23.1043 17.1382C23.1043 14.7683 22.4799 12.7227 21.2496 11.0263C20.0193 9.30501 18.5136 8.45683 16.7691 8.45683L14.4737 8.45683C12.968 8.45683 11.6826 7.73338 10.5992 6.28648C9.53413 4.83958 9.00161 2.74407 9.00161 0.0248999L16.7691 0.0249008L16.7691 -4.34774e-05Z",
    fill: "url(#paint1_linear_10955_49786)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10955_49786",
    x1: 16.5313,
    y1: 12.6891,
    x2: 2.83399,
    y2: 27.0168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868441,
    stopColor: "#1B2028"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10955_49786",
    x1: 13,
    y1: 33.9639,
    x2: 26.6973,
    y2: 19.6363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868441,
    stopColor: "#1B2028"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContaroLogo);
export default __webpack_public_path__ + "static/media/contaroLogo.49299978917b6bc136857e660b6d27e4.svg";
export { ForwardRef as ReactComponent };